import { StaticImageStandardSettings } from 'apps/studio/components/settings/fields/StaticImage/standard'
import { FieldSettingsPanel } from 'apps/studio/components/settings/fields/Base/standard'
import { DesignSettingsPanel } from 'apps/studio/components/settings/fields/Base/design'

export const StaticImageSettings = [
  FieldSettingsPanel(StaticImageStandardSettings),
  DesignSettingsPanel,
  // ConditionsPanel,
  // no advanced panel
]
